import React from 'react';
import { Check, X } from 'lucide-react';
export function BeforeAfterSection() {
  return <section className="bg-white py-10 md:py-14 px-4" data-id="element-1">
      <div className="max-w-3xl mx-auto" data-id="element-2">
        <h2 className="text-2xl md:text-4xl font-black text-center text-gray-900 mb-6 font-['Oswald'] uppercase" data-id="element-3">
          Antes vs Después
        </h2>

        <div className="grid grid-cols-2 gap-3 md:gap-4" data-id="element-4">
          {/* Before */}
          <div className="bg-red-50 p-4 md:p-6 rounded-xl border border-red-100" data-id="element-5">
            <h3 className="text-base md:text-xl font-bold text-red-700 mb-4 text-center uppercase" data-id="element-6">
              Antes del Pack
            </h3>
            <ul className="space-y-3" data-id="element-7">
              {['Improvisación constante', 'Cansancio mental', 'Clases apuradas', 'Trabajo extra en casa', 'Estrés antes de cada unidad'].map((item, idx) => <li key={idx} className="flex items-start gap-2" data-id="element-8">
                  <X className="w-4 h-4 text-red-500 flex-shrink-0 mt-0.5" data-id="element-9" />
                  <span className="text-sm md:text-base text-gray-700" data-id="element-10">
                    {item}
                  </span>
                </li>)}
            </ul>
          </div>

          {/* After */}
          <div className="bg-green-50 p-4 md:p-6 rounded-xl border border-green-200 shadow-lg relative" data-id="element-11">
            <div className="absolute -top-2 right-2 bg-green-500 text-white text-[10px] font-bold px-2 py-0.5 rounded uppercase" data-id="element-12">
              Tu nueva realidad
            </div>
            <h3 className="text-base md:text-xl font-bold text-green-700 mb-4 text-center uppercase" data-id="element-13">
              Después del Pack
            </h3>
            <ul className="space-y-3" data-id="element-14">
              {['Clases claras y organizadas', 'Material listo siempre', 'Más seguridad al explicar', 'Menos trabajo fuera del aula', 'Más tranquilidad para enseñar'].map((item, idx) => <li key={idx} className="flex items-start gap-2" data-id="element-15">
                  <div className="bg-green-500 rounded-full p-0.5 flex-shrink-0 mt-0.5" data-id="element-16">
                    <Check className="w-3 h-3 text-white" data-id="element-17" />
                  </div>
                  <span className="text-sm md:text-base text-gray-800 font-semibold" data-id="element-18">
                    {item}
                  </span>
                </li>)}
            </ul>
          </div>
        </div>

        <div className="mt-8 text-center" data-id="element-19">
          <a href="#compra" className="bg-[#22c55e] hover:bg-[#16a34a] text-white text-lg md:text-xl font-black py-4 px-8 rounded-lg shadow-[0_4px_0_#15803d] active:shadow-[0_2px_0_#15803d] active:translate-y-1 transition-all uppercase inline-flex items-center justify-center gap-2 no-underline" data-id="element-20">
            🚀 Quiero transformar mis clases ahora
          </a>
        </div>
      </div>
    </section>;
}